/** 全局快捷键。输入框聚焦时不响应。 */
import { useEffect } from 'react';
import type { Layer } from '@h5/schema';
import { findLayer, useEditorStore } from '../store/store';

let clipboard: Layer[] = []; // 编辑器内部剪贴板

function isEditable(target: EventTarget | null) {
  const el = target as HTMLElement | null;
  if (!el) return false;
  const tag = el.tagName;
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || el.isContentEditable;
}

export function useShortcuts() {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (isEditable(e.target)) return;
      const s = useEditorStore.getState();
      const mod = e.ctrlKey || e.metaKey;
      const ids = s.ui.selectedIds;

      if (mod && e.key.toLowerCase() === 'z') {
        e.preventDefault();
        e.shiftKey ? s.redo() : s.undo();
        return;
      }
      if (mod && e.key.toLowerCase() === 'y') { e.preventDefault(); s.redo(); return; }
      if (mod && e.key.toLowerCase() === 'c') {
        if (!ids.length) return;
        e.preventDefault();
        clipboard = ids.map((id) => findLayer(s.doc, id)?.layer).filter((l): l is Layer => !!l).map((l) => JSON.parse(JSON.stringify(l)));
        return;
      }
      if (mod && e.key.toLowerCase() === 'v') {
        if (!clipboard.length) return;
        e.preventDefault();
        s.pasteLayers(clipboard);
        return;
      }
      if (mod && e.key.toLowerCase() === 'd') {
        if (!ids.length) return;
        e.preventDefault();
        s.duplicateLayers(ids);
        return;
      }
      if (mod && e.key.toLowerCase() === 's') {
        e.preventDefault();
        window.dispatchEvent(new CustomEvent('h5:save'));
        return;
      }
      if (e.key === 'Delete' || e.key === 'Backspace') {
        if (!ids.length) return;
        e.preventDefault();
        s.removeLayers(ids);
        return;
      }
      if (e.key === 'Escape') { s.clearSelection(); s.setPreviewOpen(false); return; }
      if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
        if (!ids.length) return;
        e.preventDefault();
        const step = e.shiftKey ? 10 : 1;
        const dx = e.key === 'ArrowLeft' ? -step : e.key === 'ArrowRight' ? step : 0;
        const dy = e.key === 'ArrowUp' ? -step : e.key === 'ArrowDown' ? step : 0;
        s.moveLayers(ids, dx, dy);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);
}
